import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Text,
  Spinner,
  Code,
} from "@chakra-ui/react";
import rulesService from "../../services/rules.service";

// Read-only view of a stored rules snapshot (the rules in effect at some point,
// e.g. what processed an upload, or the full state after an audited change).
const FIELDS = [
  ["operator", "Operator"],
  ["threshold", "Threshold"],
  ["thresholdForNextCase", "Case freq"],
  ["thresholdCondition", "Condition"],
  ["range", "Range"],
  ["color", "Color"],
  ["datatype", "Datatype"],
  ["symbol", "Symbol"],
  ["isExactValueRequired", "Exact"],
];

const fmt = (v) => {
  if (v === true) return "Yes";
  if (v === false) return "false";
  if (v === null || v === undefined || v === "") return "—";
  return String(v);
};

function RuleSnapshotModal({ isOpen, onClose, hash, title }) {
  const [rules, setRules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen || !hash) return;
    setLoading(true);
    setError("");
    setRules(null);
    rulesService.getSnapshot(hash).then((res) => {
      setLoading(false);
      if (res && res.rules) setRules(res.rules);
      else setError((res && (res.warning || res.error)) || "Snapshot not found");
    });
  }, [isOpen, hash]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="5xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="md">
          {title || "Rules snapshot"}{" "}
          {hash ? <Code fontSize="0.7em">{hash.slice(0, 12)}</Code> : null}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {loading && (
            <Box textAlign="center" py={6}>
              <Spinner />
            </Box>
          )}
          {error && (
            <Text color="red.500" fontSize="sm">
              {error}
            </Text>
          )}
          {rules && (
            <Table size="sm" variant="striped">
              <Thead>
                <Tr>
                  <Th>Column</Th>
                  {FIELDS.map(([, label]) => (
                    <Th key={label}>{label}</Th>
                  ))}
                </Tr>
              </Thead>
              <Tbody>
                {Object.entries(rules).map(([col, def]) => (
                  <Tr key={col}>
                    <Td fontWeight="500">{col}</Td>
                    {FIELDS.map(([field]) => (
                      <Td key={field}>
                        {field === "color" && def[field] ? (
                          <Box as="span" px={2} borderRadius="sm" backgroundColor={def[field]}>
                            {fmt(def[field])}
                          </Box>
                        ) : (
                          fmt(def[field])
                        )}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default RuleSnapshotModal;
